<div [@pageLoad]="pageLoadState" class="success-page-host">
  <div class="success-page flex flex-col h-[100%] w-[100%] shrink-0 justify-start items-center px-[24px] md:px-[48px] lg:px-[64px] py-[40px] bg-[#f7fafc]">
    <div class="success-content gap-[24px] flex flex-col w-[100%] max-w-[1388px] shrink-0 justify-start items-center">

      <div class="w-full max-w-[1200px] flex flex-row items-center justify-start">
        <NiButton
          variant="outlined"
          color="secondary"
          size="Large"
          label="Back"
          leadingIcon="arrowNarrowLeft"
          (onClick)="onBackClick()">
        </NiButton>
      </div>

      <!-- Title -->
      <div class="success-title-block gap-[16px] flex flex-col shrink-0 justify-center items-center">
        <img
          src="assets/icons/Icon.png"
          alt=""
          loading="lazy"
          decoding="async"
          class="w-[56px] h-[56px] shrink-0 success-icon"
          aria-hidden="true" />
        <h1 class="success-title m-0 text-[#111215] text-center font-bold font-['archivo'] text-[28px] leading-[36px]">
          You have checked-in Successfully!
        </h1>
        <p class="m-0 text-[#444955] text-center font-normal font-['archivo'] text-[18px] leading-[28px] max-w-[720px]">
          Here is a summary of your upcoming selections. Click Edit on any day to modify meals or transportation.
        </p>
      </div>

      <p
        *ngIf="isLoadingSummary"
        class="m-0 text-[#667085] font-['archivo'] text-[16px]">
        Loading your plan summary...
      </p>

      <!-- Meal & Transportation by day -->
      <div
        *ngIf="!isLoadingSummary && planDays.length > 0"
        class="success-schedule w-full"
        aria-label="Meal and Transportation Schedule">
        <h2 class="success-section-title">Meal &amp; Transportation</h2>
        <div class="success-table-wrap">
          <table class="success-table">
            <thead>
              <tr>
                <th scope="col" class="success-table__col-date">
                  <span class="sr-only">Date</span>
                </th>
                <th scope="col" class="success-table__col-meal">Meal</th>
                <th scope="col" class="success-table__col-transport">Transportation</th>
                <th scope="col" class="success-table__col-action">
                  <span class="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of planDays">
                <td class="success-table__date">{{ dateLabel(row.dateLabel) }}</td>
                <td
                  class="success-table__cell"
                  [class.success-table__muted]="!row.mealScheduled">
                  {{ mealDisplay(row) }}
                </td>
                <td
                  class="success-table__cell"
                  [class.success-table__muted]="!row.transportScheduled">
                  {{ row.transportLabel || 'None' }}
                </td>
                <td class="success-table__action">
                  <button
                    type="button"
                    class="success-table__edit"
                    [attr.aria-label]="'Edit plan for ' + dateLabel(row.dateLabel)"
                    (click)="onEditClick(row.dateValue)">
                    Edit
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Activities section (supports many activities without crowding the meal table) -->
      <section
        *ngIf="!isLoadingSummary"
        class="success-section w-full"
        aria-label="Activities">
        <h2 class="success-section-title">Activities</h2>
        <div *ngIf="activityDays.length === 0" class="success-section-empty">
          No activities scheduled.
        </div>
        <div *ngIf="activityDays.length > 0" class="success-activity-list">
          <article
            *ngFor="let day of activityDays"
            class="success-activity-card">
            <div class="success-activity-card__date">{{ dateLabel(day.dateLabel) }}</div>
            <ul class="success-activity-card__names">
              <li *ngFor="let name of day.activityNames">{{ name }}</li>
            </ul>
          </article>
        </div>
      </section>

      <!-- Special Events section -->
      <section
        *ngIf="!isLoadingSummary"
        class="success-section w-full"
        aria-label="Special Events">
        <h2 class="success-section-title">Special Events</h2>
        <div *ngIf="registeredEvents.length === 0" class="success-section-empty">
          No special events registered.
        </div>
        <div
          *ngIf="registeredEvents.length > 0"
          class="success-event-rows w-full"
          aria-label="Registered Special Events">
          <article
            *ngFor="let event of registeredEvents"
            class="success-event-row">
            <div class="success-event-row__date">{{ event.date || '—' }}</div>
            <button
              type="button"
              class="success-event-row__title"
              [attr.aria-label]="'View event: ' + event.title"
              (click)="onViewRegisteredEvent(event)">
              {{ event.title }}
            </button>
            <span
              class="success-event-row__badge"
              [class.success-event-row__badge--waitlist]="event.isWaitlisted"
              [class.success-event-row__badge--registered]="!event.isWaitlisted">
              {{ eventStatusLabel(event) }}
            </span>
            <div class="success-event-row__spacer" aria-hidden="true"></div>
            <button
              type="button"
              class="success-table__edit"
              [disabled]="cancellingEventId === event.id"
              [attr.aria-label]="'Cancel registration for ' + event.title"
              (click)="onCancelRegisteredEvent(event)">
              {{ cancellingEventId === event.id ? 'Cancelling...' : 'Cancel' }}
            </button>
          </article>
        </div>
      </section>

      <NiButton
        variant="contained"
        color="primary"
        size="[20px]"
        label="Go to Home"
        [px]="'[40px]'"
        [py]="'[16px]'"
        [rounded]="'[999px]'"
        bg="[#f26f24ff]"
        textColor="#ffffff"
        (onClick)="onDoneClick()"
        [styleClass]="'success-done-btn'">
      </NiButton>
    </div>
  </div>
</div>
